// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1152) return "static/chunks/1152-77c58ebef3833fb0.js";
	if (chunkId === 4519) return "static/chunks/4519-16d000cf0c85d78a.js";
	if (chunkId === 4721) return "static/chunks/4721-c2e6b0a79cf13952.js";
	if (chunkId === 1329) return "static/chunks/1329-9af8a2d210cddd94.js";
	if (chunkId === 7120) return "static/chunks/7120-abdf80e3013e3d9a.js";
	if (chunkId === 2270) return "static/chunks/2270-3b6ced755fc65646.js";
	if (chunkId === 9824) return "static/chunks/9824-79a3658052212f56.js";
	if (chunkId === 1595) return "static/chunks/1595-a7251038e499f21a.js";
	if (chunkId === 1964) return "static/chunks/1964-f4acce56cd08dc25.js";
	if (chunkId === 2606) return "static/chunks/2606-4b9d70fd34b54f55.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3200":"fec483df","5436":"72a30a16","9910":"bf41aa9e"}[chunkId] || chunkId) + "." + {"1336":"8155238b8a485a1c","1801":"9506f194e824236e","2486":"63efc11725c5d2e6","2838":"92972069ca97827b","2983":"1bdcebf605110c91","3058":"0217e8d955855b05","3200":"7ae2b2298212fde5","5436":"32fe587da14d0cf8","9466":"e1e52421ee0c639e","9910":"b9b5de5c66079c40"}[chunkId] + ".js";
};